import { useTranslation } from "react-i18next";
import { getUserFriendlyErrorMessage, ErrorMessages } from "@/utils/error-message.utils";

export function useErrorMessage() {
  const { t } = useTranslation();

  const getErrorMessages = (): ErrorMessages => ({
    unauthorized: t('errors.unauthorized'),
    forbidden: t('errors.forbidden'),
    notFound: t('errors.notFound'),
    serverUnavailable: t('errors.serverUnavailable'),
    offline: t('errors.offline'),
    validationError: t('errors.validationError'),
    generic: t('errors.generic'),
  });

  const getErrorMessage = (error: unknown): string => {
    return getUserFriendlyErrorMessage(error, getErrorMessages());
  };

  return { getErrorMessage, getErrorMessages };
}
